import React from 'react';
import PropTypes from 'prop-types';
import StrModal from '../../shared/StrModal';
import { useFileUpload } from './useFileUpload';
import FileUploadModal from "./FileUploadModal";


const BrandLogoField = ({ logoUrl, onLogoUrlChange }) => {
  const [modalOpen, setModalOpen] = React.useState(false);

  const handleOpenModalClick = () => {
    setModalOpen(true);
  };

  const {
    status,
    filename,
    filePayload,
    error,
    uploadFile,
    uploadPercent
  } = useFileUpload('/brand_logos');

  const closeModal = () => setModalOpen(false);

  React.useEffect(
    function uploadSuccess() {
      if (status === 'success') {
        setModalOpen(false);
      }
    },
    [status]
  );

  React.useEffect(
    function updateLogoUrl() {
      if (filePayload) {
        onLogoUrlChange(filePayload.url);
      }
    },
    [filePayload]
  );

  if (modalOpen) {
    return (
      <StrModal title="Upload Brand Logo" open hideModal={closeModal}>
        <FileUploadModal
          filename={filename}
          loading={status === 'loading'}
          error={error}
          onUpload={uploadFile}
          uploadPercent={uploadPercent}
        />
      </StrModal>
    );
  } else {
    return (
      <>
        {logoUrl ? (
          <>
            <div
              className="thumbnail-container col-xs-4"
              style={{
                backgroundImage: `url('${logoUrl}')`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
              }}
            />
            <div className="change-logo-container col-xs-6">
              <button
                type="button"
                onClick={handleOpenModalClick}
                tabIndex={0}
                className="btn btn-secondary clickable"
              >
                Change
              </button>
              <button
                type="button"
                className="btn btn-secondary clickable ml1"
                onClick={() => onLogoUrlChange(null)}
                tabIndex={0}
              >
                Delete
              </button>
            </div>
          </>
        ) : (
          <button
            type="button"
            onClick={handleOpenModalClick}
            tabIndex={0}
            className="add-logo-button mt2"
          >
            Add Brand Logo
          </button>
        )}
      </>
    );
  }
};

BrandLogoField.propTypes = {
  logoUrl: PropTypes.string,
  onLogoUrlChange: PropTypes.func.isRequired
};

export default BrandLogoField;
